/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CaseOverviewColumn {
  Department = 0,
  TransportType = 1,
  EcomId = 2,
  Status = 3,
  InvoicingStatus = 4,
  CreatedDate = 5,
  Customer = 6,
  Reference = 7,
  InvoiceRecipients = 8,
  Sender = 9,
  Receiver = 10,
  CustomsId = 11,
  SequenceNumber = 12,
  Mrn = 13,
  HasSlaTime = 14,
  Contact = 15,
  TransportIdentityArrival = 16,
  ContainerNumbers = 17,
  HouseAirWaybill = 18,
  MasterAirWaybill = 19,
  SwedishTaxPayerType = 20,
  SeStatus = 21,
  NoStatus = 22,
  Documents = 23,
  DeliveryConditionCode = 24,
  ImportDeclarationCode = 25,
  ExportDeclarationCode = 26,
  InvoiceNumber = 27,
  GrossWeight = 28,
  LineNumber = 29,
}
